/* ===== Superfly theme JS — cart drawer, GTM dataLayer, carousels, quiz, FAQ ===== */


(function(){
  'use strict';
  window.dataLayer = window.dataLayer || [];
  const dl = (ev) => window.dataLayer.push(ev);
  const formatINR = (n) => "₹" + (Number(n)/100).toFixed(0);
  const $  = (s,r=document) => r.querySelector(s);
  const $$ = (s,r=document) => [...r.querySelectorAll(s)];

  /* ----- Sticky header ----- */
  const header = $('.site-header');
  if(header){
    const onScroll = () => header.classList.toggle('scrolled', window.scrollY>20);
    onScroll(); window.addEventListener('scroll', onScroll, {passive:true});
  }

  /* ----- Mobile menu ----- */
  const burger = $('#burger'), mobileDrawer = $('#mobile-drawer');
  if(burger && mobileDrawer){
    burger.addEventListener('click', ()=> mobileDrawer.classList.toggle('open'));
  }

  /* ----- Toast ----- */
  const toastEl = $('#sf-toast');
  const toast = (msg) => {
    if(!toastEl) return;
    toastEl.textContent = msg; toastEl.classList.add('show');
    clearTimeout(toast._t); toast._t = setTimeout(()=>toastEl.classList.remove('show'), 2200);
  };

  /* ===== CART ===== */
  const cart = {
    data: null,
    async fetch(){
      const r = await fetch('/cart.js', {cache:'no-store'});
      this.data = await r.json();
      this.render();
      return this.data;
    },
    async add(variantId, quantity=1, item={}){
      const r = await fetch('/cart/add.js', {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({items:[{id:variantId, quantity}]})
      });
      if(!r.ok){ toast("Couldn't add — try again"); return; }
      const line = await r.json();
      await this.fetch();
      dl({event:'add_to_cart', currency:'INR', value: (line.price*quantity)/100,
          items:[{item_id:line.product_id, item_name:line.product_title||item.title,
                  item_variant:line.variant_title, price:line.price/100, quantity}]});
      this.open();
      toast("Added · " + (item.title || line.product_title || 'Bite-free'));
    },
    async change(line, quantity){
const r = await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body: JSON.stringify({line, quantity})}); if(!r.ok){ toast("Couldn't update cart — try again"); return; } await this.fetch();
      if(quantity===0) dl({event:'remove_from_cart'});
    },
    open(){ $('#cart-drawer')?.classList.add('open'); $('#cart-overlay')?.classList.add('open');
            dl({event:'view_cart', value: (this.data?.total_price||0)/100}); },
    close(){ $('#cart-drawer')?.classList.remove('open'); $('#cart-overlay')?.classList.remove('open'); },
    render(){
      const drawer = $('#cart-drawer-body'); if(!drawer||!this.data) return;
      const items = this.data.items || [];
      const subtotal = this.data.total_price||0;
      const threshold = Number(drawer.dataset.threshold||30000); // paise (₹300 default)
      const remain = Math.max(0, threshold - subtotal);
      const pct = Math.min(100, (subtotal/threshold)*100);

      // Tiered upsell copy
      const totalQty = items.reduce((a,i)=>a+i.quantity, 0);
      const t1Qty = Number(drawer.dataset.tier1qty||1);
      const t1Pct = Number(drawer.dataset.tier1pct||10);
      const t2Qty = Number(drawer.dataset.tier2qty||2);
      const t2Pct = Number(drawer.dataset.tier2pct||15);
      let upsellMsg = '';
      if(totalQty>=1 && totalQty<1+t1Qty)
        upsellMsg = `Add 1 more bottle & save <b>${t1Pct}%</b>`;
      else if(totalQty>=1+t1Qty && totalQty<1+t1Qty+t2Qty-1)
        upsellMsg = `${t1Pct}% unlocked. Add 1 more & save <b>${t2Pct}%</b>`;
      else if(totalQty>=1+t1Qty+t2Qty-1 && totalQty>0)
        upsellMsg = `🌸 ${t2Pct}% off unlocked — max saver`;

      $('#cart-count').textContent = this.data.item_count;

      // Free shipping bar
      const shipHtml = subtotal===0 ? '' :
        remain<=0
          ? `<div class="ship-bar"><p>🌸 Free shipping unlocked</p><div class="track"><div class="fill" style="width:100%"></div></div></div>`
          : `<div class="ship-bar"><p>${formatINR(remain)} away from free shipping</p><div class="track"><div class="fill" style="width:${pct}%"></div></div></div>`;

      const upsellHtml = upsellMsg ? `<div class="upsell-bar">${upsellMsg}</div>` : '';

      if(items.length===0){
        drawer.innerHTML = `
          ${shipHtml}
          <div class="cart-empty">
            <p class="font-chantal" style="font-size:2rem;margin:16px 0">your cart is empty.</p>
            <p style="opacity:.7;margin-bottom:24px">Pick your scent — we'll do the rest.</p>
            <a href="/collections/all" class="btn btn-ink">Shop all scents</a>
          </div>`;
        const foot=$('#cart-foot'); if(foot) foot.style.display='none';
        return;
      }
      const itemsHtml = items.map((l,idx)=>`
        <div class="cart-item">
          <img src="${l.image||''}" alt="${l.product_title}">
          <div class="info">
            <h4>${l.product_title}</h4>
            <p class="tagline">${(l.variant_title||'').toLowerCase()}</p>
            <div class="qty">
              <button data-line="${idx+1}" data-q="${l.quantity-1}">−</button>
              <span>${l.quantity}</span>
              <button data-line="${idx+1}" data-q="${l.quantity+1}">+</button>
            </div>
            <button class="remove" data-line="${idx+1}" data-q="0">Remove</button>
          </div>
          <div style="text-align:right;font-weight:700">${formatINR(l.final_line_price)}</div>
        </div>`).join('');

      drawer.innerHTML = shipHtml + itemsHtml;
      $('#cart-foot').style.display='block';
      $('#cart-subtotal').textContent = formatINR(subtotal);
      $('#cart-upsell').innerHTML = upsellHtml;

      drawer.querySelectorAll('[data-line]').forEach(b=>{
        b.addEventListener('click',(e)=>{
          const line=Number(b.dataset.line), q=Number(b.dataset.q);
          cart.change(line, q);
        });
      });
    }
  };
  window.sfCart = cart;
  cart.fetch();

  // Cart UI hooks
  $('#cart-close')?.addEventListener('click', ()=>cart.close());
  $('#cart-overlay')?.addEventListener('click', ()=>cart.close());
  $$('[data-cart-open]').forEach(el=>el.addEventListener('click',(e)=>{e.preventDefault();cart.open();}));

  // PDP "Add to cart" forms
  $$('form.product-form').forEach(form=>{
    const dataEl = form.querySelector('[data-pdp-form]') || form;
    form.addEventListener('submit', async (e)=>{
      e.preventDefault();
      const fd = new FormData(form);
      const id = fd.get('id'); const q = Number(fd.get('quantity')||1);
      const title = dataEl.dataset.title || '';
      dl({event:'add_to_cart', currency:'INR',
          items:[{item_id:dataEl.dataset.productId, item_name:title, quantity:q}]});
      await cart.add(id, q, {title});
    });
  });

  // Product-grid "Add to cart" buttons (inline on range/home)
  $$('.prange-add[data-variant-id]').forEach(btn=>{
    btn.addEventListener('click', async (e)=>{
      e.preventDefault();
      e.stopPropagation();
      if(btn.disabled || btn.classList.contains('loading')) return;
      const vid = btn.dataset.variantId;
      const title = btn.dataset.title || '';
      if(!vid || vid==='' || vid==='0'){ toast("Pick this product's page to add"); return; }
      btn.classList.add('loading');
      const original = btn.textContent;
      btn.textContent = 'Adding…';
      try{
        await cart.add(vid, 1, {title});
        btn.textContent = 'Added ✓';
        setTimeout(()=>{ btn.textContent = original; btn.classList.remove('loading'); }, 1400);
      }catch(err){
        btn.textContent = original;
        btn.classList.remove('loading');
      }
    });
  });

  // Checkout btn
  $$('[data-checkout]').forEach(b=>{
    b.addEventListener('click',(e)=>{
      e.preventDefault();
      dl({event:'begin_checkout', currency:'INR', value:(cart.data?.total_price||0)/100,
          items:(cart.data?.items||[]).map(l=>({item_id:l.product_id,item_name:l.product_title,quantity:l.quantity,price:l.price/100}))});
      window.location.href='/checkout';
    });
  });

  // View item event on PDP
  const pdpEl = document.getElementById('pdp-evt-data');
  if(pdpEl){
    dl({
      event: 'view_item',
      currency: 'INR',
      value: Number(pdpEl.dataset.value) || 0,
      items: [{
        item_id: pdpEl.dataset.itemId,
        item_name: pdpEl.dataset.itemName,
        item_brand: 'Superfly',
        price: Number(pdpEl.dataset.value) || 0
      }]
    });
  }

  /* ===== Quantity controls on PDP ===== */
  $$('.qty-ctrl').forEach(c=>{
    const span=c.querySelector('span'), inp=c.querySelector('input');
    c.querySelectorAll('button').forEach(b=>b.addEventListener('click',()=>{
      let v=Number(span.textContent)||1;
      v = b.dataset.dir==='up'?v+1:Math.max(1,v-1);
      span.textContent=v; if(inp) inp.value=v;
    }));
  });

  /* ===== FAQ accordion ===== */
  $$('.faq-item .faq-q').forEach(b=>{
    b.addEventListener('click',()=>{
      const item=b.closest('.faq-item');
      item.classList.toggle('open');
    });
  });

  /* ===== Newsletter fake submit (Shopify Contact form actually handles it) ===== */
  $$('form[data-newsletter]').forEach(f=>{
    f.addEventListener('submit', (e)=>{ setTimeout(()=>toast("You're in. Watch your inbox."),50); });
  });

  /* ===== PDP tabs ===== */
  $$('.pdp-tabs').forEach(wrap=>{
    const tabs = wrap.querySelectorAll('[data-tab]');
    const panels = wrap.parentElement.querySelectorAll('[data-panel]');
    tabs.forEach(t=>t.addEventListener('click',()=>{
      tabs.forEach(x=>x.classList.remove('active'));
      t.classList.add('active');
      panels.forEach(p=>p.style.display = p.dataset.panel===t.dataset.tab ? 'block':'none');
    }));
  });

  /* ===== Quiz (client-side state machine) ===== */
  const quizEl = $('#quiz'); if(quizEl){
    const qJson = document.getElementById('quiz-questions-data');
    const pJson = document.getElementById('quiz-products-data');
    const questions = qJson ? JSON.parse(qJson.textContent||'[]') : [];
    const products = pJson ? JSON.parse(pJson.textContent||'{}') : {};
    let step=0, scores={};
    const panels = { intro:$('#quiz-intro'), q:$('#quiz-q'), result:$('#quiz-result') };
    function render(){
      panels.intro.style.display = step===0 ? 'block':'none';
      panels.q.style.display = step>0 && step<=questions.length ? 'block':'none';
      panels.result.style.display = step>questions.length ? 'block':'none';
      if(step>0 && step<=questions.length){
        const qi = step-1, q = questions[qi];
        $('#quiz-progress').innerHTML = questions.map((_,i)=>`<div class="step ${i<=qi?'on':''}"></div>`).join('');
        $('#quiz-q-num').textContent = 'Question 0'+(qi+1)+' of 0'+questions.length;
        $('#quiz-q-title').textContent = q.q;
        $('#quiz-q-options').innerHTML = q.options.map((o,i)=>`<button class="quiz-option" data-opt="${i}">
          <span style="font-size:1.25rem;font-weight:700;flex:1">${o.label}</span><span>→</span></button>`).join('');
        $$('.quiz-option', $('#quiz-q-options')).forEach(b=>b.addEventListener('click',()=>{
          const opt = q.options[Number(b.dataset.opt)];
          Object.entries(opt.weights).forEach(([k,v])=>{ scores[k]=(scores[k]||0)+v; });
          step++; render();
        }));
      }
      if(step>questions.length){
        const winnerId = Object.entries(scores).sort((a,b)=>b[1]-a[1])[0]?.[0] || Object.keys(products)[0];
        const p = products[winnerId];
        $('#quiz-winner').innerHTML = p ? `
          <div class="pdp-imgcard ${p.bg}"><img src="${p.img}" alt="${p.name}" class="bottle" style="position:static;width:auto;max-width:60%"></div>
          <div>
            <div class="pill">✓ Your match</div>
            <h2 class="display" style="font-size:4rem;margin:16px 0 8px">${p.name}</h2>
            <p class="font-chantal" style="font-size:1.5rem">${p.tagline}</p>
            <p style="max-width:480px;margin:24px 0;font-size:1.125rem;line-height:1.5">${p.desc}</p>
            <a href="${p.url}" class="btn btn-ink">Shop ${p.name} →</a>
            <button id="quiz-restart" class="btn btn-ghost" style="margin-left:12px">Retake quiz</button>
          </div>` : '';
        $('#quiz-restart')?.addEventListener('click',()=>{ step=0; scores={}; render(); });
      }
    }
    $('#quiz-start')?.addEventListener('click',()=>{ step=1; render(); });
    render();
  }

})();
